/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
// import React, { useState } from "react";

import Select from "react-select";
// import "../../../index.css";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import {
  getSubModulesByRoleId,
  saveExtractedData,
  uploadStructure01,
  uploadStructure02,
  uploadStructure03,
  uploadStructure04,
  uploadStructure05,
  uploadStructure09,
} from "../../store";

// @mui material icons

import Cookies from "universal-cookie";

const cookies = new Cookies();

const OCR = ({
  uploadStructure01,
  uploadStructure02,
  uploadStructure03,
  uploadStructure04,
  uploadStructure05,
  uploadStructure09,
  saveExtractedData,
  ocrUploadStructure1Reducer,
  ocrUploadStructure9Reducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ocrModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "a2ac0de2-9da7-4b06-acec-23efdf58d91c",
  );

  let uploadAccess = ocrModule
    ? ocrModule.actionId.includes("da1b66b4-5022-4d42-b500-bc44523ebab2")
    : null;

  let submitAccess = ocrModule
    ? ocrModule.actionId.includes("b5c0a887-8bdd-4c9c-bcfa-38ed0d389068")
    : null;

  const [structureType, setStructureType] = useState("vendor4");

  const [extractedData, setExtractedData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [finalData, setFinalData] = useState({});

  const [ocrDataS1, setOcrDataS1] = useState([]);

  const [loading, setLoading] = useState(false);
  const [buttonName, setButtonName] = useState("Submit Data");

  useEffect(() => {
    const data = ocrUploadStructure1Reducer.ocrData?.length
      ? ocrUploadStructure1Reducer.ocrData
      : [];
    setOcrDataS1(data);
  }, [ocrUploadStructure1Reducer]);

  // 2. Structure-wise input fields config
  const structureFields = {
    vendor4: [
      { label: "Vendor Name", name: "vendorName" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "Shipment Date", name: "shipmentDate" },
      // { label: "Port of Destination", name: "portOfDestination" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Payment Term", name: "paymentTerm" },
      { label: "GST", name: "gst" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "PO Number", name: "poNumber" },
      {
        label: "Line Items",
        name: "lineItem",
        fields: [
          { label: "P.O.", name: "P.O." },
          { label: "Description of Goods", name: "Description of Goods" },
          // { label: "HS Code", name: "HS Code" },
          { label: "HSN/SAC Code", name: "HSN/SAC Code" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "Amount", name: "Amount" },
        ],
      },
    ],
    vendor5: [
      { label: "GST", name: "gst" },
      { label: "Vendor Name", name: "vendorName" },
      { label: "Vendor Code", name: "vendorCode" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "Shipment Date", name: "shipmentDate" },
      // { label: "Port of Destination", name: "portOfDestination" },
      { label: "Payment Term", name: "paymentTerm" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "PO Number", name: "poNumber" },
      {
        label: "Line Items",
        name: "lineItem",
        fields: [
          { label: "P.O.", name: "P.O." },
          { label: "Description of Goods", name: "Description of Goods" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "HSN/SAC", name: "HSN/SAC" },
          { label: "Item Code", name: "Item Code" },
          { label: "Amount", name: "Amount" },
        ],
      },
    ],

    vendor6: [
      // { label: "GST", name: "gst" },
      // { label: "Total Amount", name: "totalAmount" },
      // { label: "Invoice Number", name: "invoiceNumber" },
      // { label: "PO Number", name: "poNumber" },
      // {
      //   label: "Line Items",
      //   name: "lineItem",
      //   fields: [
      //     { label: "Item No", name: "Item No" },
      //     { label: "Description", name: "Description" },
      //     { label: "Quantity", name: "Quantity" },
      //     { label: "Unit Price", name: "Unit Price" },
      //     { label: "Number Of Months", name: "Number Of Months" },
      //     { label: "Total Amount", name: "Total Amount" },
      //   ],
      // },

      { label: "Vendor Name", name: "vendorName" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "Shipment Date", name: "shipmentDate" },
      // { label: "Port of Destination", name: "portOfDestination" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Payment Term", name: "paymentTerm" },

      // { label: "GST", name: "gst" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "PO Number", name: "poNumber" },
      {
        label: "Line Items",
        name: "lineItem",
        fields: [
          { label: "P.O.", name: "P.O." },
          { label: "Description of Goods", name: "Description of Goods" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "HSN/SAC", name: "HSN/SAC" },
          { label: "Item Code", name: "Item Code" },
          { label: "Amount", name: "Amount" },
        ],
      },
    ],

    vendor7: [
      { label: "GST", name: "gst" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "PO Number", name: "poNumber" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "Payment Term", name: "paymentTerm" },
      { label: "Vendor Code", name: "vandorCode" },
      { label: "Vendor Name", name: "vendorName" },
      { label: "Shipment Date", name: "shipmentDate" },
      {
        label: "Line Items",
        name: "lineItem",
        fields: [
          { label: "P.O.", name: "P.O." },
          { label: "Item Code", name: "Item Code" },
          { label: "Description of Goods", name: "Description of Goods" },
          { label: "HSN/SAC", name: "HSN/SAC" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "Amount", name: "Amount" },
        ],
      },
    ],
    vendor8: [
      { label: "VAT", name: "gst" },
      { label: "Vendor Name", name: "vendorName" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "Vendor Code", name: "vandorCode" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Payment Term", name: "paymentTerm" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "PO Number", name: "poNumber" },
      {
        label: "Line Items",
        name: "lineItem",
        fields: [
          { label: "Item Code", name: "Item Code" },
          { label: "Description of Goods", name: "Description of Goods" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "Amount", name: "Amount" },
          { label: "Tax %", name: "Tax %" },
          { label: "Tax Amount", name: "Tax Amount" },
        ],
      },
    ],

    vendor9: [
      { label: "VAT", name: "gst" },
      { label: "Vendor Name", name: "vendorName" },
      { label: "Invoice Number", name: "invoiceNumber" },
      { label: "Invoice Date", name: "invoiceDate" },
      { label: "Vendor Code", name: "vendorCode" },
      { label: "Delivery To", name: "deliveryTo" },
      { label: "Payment Term", name: "paymentTerm" },
      { label: "Total Amount", name: "totalAmount" },
      { label: "PO Number", name: "poNumber" },

      // { label: "Shipment Date", name: "shipmentDate" },
      {
        label: "Line Items",
        name: "lineItem",
        // fields: [
        //   { label: "Item Code", name: "Item Code" },
        //   { label: "Description", name: "Description of Goods" },
        //   { label: "Quantity", name: "Quantity" },
        //   { label: "Unit Price", name: "Unit Price" },
        //   { label: "Amount (Before VAT)", name: "Amount Before VAT" },
        //   { label: "Tax Amount", name: "Tax Amount" },
        //   { label: "Total Amount", name: "Total Amount" },
        //   { label: "HS Code", name: "HS Code" },
        //   { label: "PO Number", name: "PO Number" },
        // ],
        fields: [
          { label: "Item Code", name: "Item Code" },
          { label: "Description of Goods", name: "Description of Goods" },
          { label: "Quantity", name: "Quantity" },
          { label: "Unit Price", name: "Unit Price" },
          { label: "Amount", name: "Amount" },
          { label: "Tax %", name: "Tax %" },
          { label: "Tax Amount", name: "Tax Amount" },
        ],
      },
    ],
  };

  const handleExtract = async () => {
    if (!structureType || !selectedImage) {
      toast.error("Please select vendor and image");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedImage);
    setLoading(true);

    let res;

    if (structureType === "vendor6") {
      res = await uploadStructure01(formData, jwtToken);
    } else if (structureType === "vendor5") {
      res = await uploadStructure02(formData, jwtToken);
    } else if (structureType === "vendor4") {
      res = await uploadStructure03(formData, jwtToken);
    } else if (structureType === "vendor7") {
      res = await uploadStructure04(formData, jwtToken);
    } else if (structureType === "vendor8") {
      res = await uploadStructure05(formData, jwtToken);
    } else if (structureType === "vendor9") {
      res = await uploadStructure09(formData, jwtToken);
    }

    setLoading(false);

    const payload = res?.data;
    // const payload = ocrDataS1;

    if (!res?.status || !payload) {
      toast.error("Extraction failed");
      return;
    }

    const header = payload.headerData || {};

    const mappedHeader = {};
    structureFields[structureType]
      .filter((f) => f.name !== "lineItem")
      .forEach((field) => {
        mappedHeader[field.name] = header[field.name] || "";
      });

    const skv = Array.isArray(payload.structuredKeyValue)
      ? payload.structuredKeyValue
      : [];

    const lineItemFields = structureFields[structureType].find(
      (f) => f.name === "lineItem",
    ).fields;
    const lineItemsForUI = skv.map((row, idx) => {
      const item = {};
      lineItemFields.forEach((field) => {
        if (structureType === "vendor4") {
          if (field.name === "P.O.") {
            item[field.name] = row["PO Number"] ?? row["P.O."] ?? "";
          } else if (field.name === "Description of Goods") {
            item[field.name] =
              row["Commodity Description"] ?? row["Description of Goods"] ?? "";
          } else {
            item[field.name] = row[field.name] ?? "";
          }
        } else {
          item[field.name] = row[field.name] ?? "";
        }
      });
      return item;
    });

    const newExtractedData = {
      ...mappedHeader,
      structuredKeyValue: skv,
      lineItem: lineItemsForUI.length ? lineItemsForUI : undefined,
    };

    setExtractedData(newExtractedData);
    setFinalData(JSON.parse(JSON.stringify(newExtractedData)));
  };

  const handleExtractedInputChange = (e) => {
    setFinalData({
      ...finalData,
      [e.target.name]: e.target.value,
    });
  };

  const handleStructureChange = (option) => {
    const selected = option.value;
    setStructureType(selected);
    setExtractedData({});
    setSelectedImage(null);

    const hasLineItem = structureFields[selected]?.some(
      (f) => f.name === "lineItem",
    );

    setFinalData(hasLineItem ? { lineItem: [{}] } : {});
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const handleSubmitExtracted = async (e) => {
    e.preventDefault();
    setButtonName("Submitting...");
    setLoading(true);

    const headerFields =
      structureFields[structureType]?.filter((f) => f.name !== "lineItem") ||
      [];
    const headerData = {};
    headerFields.forEach((field) => {
      headerData[`${field.name}Extracted`] = extractedData[field.name] || "";
      headerData[`${field.name}Final`] =
        finalData[field.name] || extractedData[field.name] || "";
    });

    let structuredKeyValue = [];
    const lineItemConfig = structureFields[structureType]?.find(
      (f) => f.name === "lineItem",
    );
    if (lineItemConfig && Array.isArray(finalData.lineItem)) {
      structuredKeyValue = finalData.lineItem.map((item, idx) => {
        const extractedItem =
          (extractedData.lineItem && extractedData.lineItem[idx]) || {};
        const obj = {};
        if (structureType === "vendor6") {
          obj["Item No"] = item["Item No"] || extractedItem["Item No"] || "";
          lineItemConfig.fields.forEach((field) => {
            if (field.name !== "Item No") {
              let apiKey = field.name;
              if (apiKey === "Unit Price") apiKey = "UnitPrice";
              if (apiKey === "Number Of Months") apiKey = "NumberOfMonths";
              if (apiKey === "Total Amount") apiKey = "TotalAmount";
              obj[`${apiKey}Extracted`] = extractedItem[field.name] || "";
              obj[`${apiKey}Final`] =
                item[field.name] || extractedItem[field.name] || "";
            }
          });
        } else if (structureType === "vendor5") {
          lineItemConfig.fields.forEach((field) => {
            let apiKey = field.name;
            if (apiKey === "Unit Price") apiKey = "UnitPrice";
            if (apiKey === "PO Number") apiKey = "PONumber";
            if (apiKey === "Item Code") apiKey = "ItemCode";
            if (apiKey === "Description of Goods") apiKey = "Description";
            obj[`${apiKey}Extracted`] = extractedItem[field.name] || "";
            obj[`${apiKey}Final`] =
              item[field.name] || extractedItem[field.name] || "";
          });
        } else if (structureType === "vendor4") {
          lineItemConfig.fields.forEach((field) => {
            let apiKey = field.name;
            if (apiKey === "Unit Price") apiKey = "UnitPrice";
            if (apiKey === "Description of Goods")
              apiKey = "DescriptionOfGoods";
            if (apiKey === "P.O.") apiKey = "PO";
            obj[`${apiKey}Extracted`] = extractedItem[field.name] || "";
            obj[`${apiKey}Final`] =
              item[field.name] || extractedItem[field.name] || "";
          });
        } else if (structureType === "vendor7") {
          lineItemConfig.fields.forEach((field) => {
            let apiKey = field.name;

            if (apiKey === "Unit Price") apiKey = "UnitPrice";
            if (apiKey === "Description of Goods")
              apiKey = "DescriptionOfGoods";
            if (apiKey === "HSN/SAC") apiKey = "HSNSAC";
            if (apiKey === "Item Code") apiKey = "ItemCode";
            obj[`${apiKey}Extracted`] = extractedItem[field.name] || "";
            obj[`${apiKey}Final`] =
              item[field.name] || extractedItem[field.name] || "";
          });
        } else if (structureType === "vendor8") {
          lineItemConfig.fields.forEach((field) => {
            let apiKey = field.name;

            if (apiKey === "Unit Price") apiKey = "UnitPrice";
            if (apiKey === "Description of Goods") apiKey = "description";
            if (apiKey === "HSN/SAC") apiKey = "HSNSAC";
            if (apiKey === "Item Code") apiKey = "ItemCode";
            obj[`${apiKey}Extracted`] = extractedItem[field.name] || "";
            obj[`${apiKey}Final`] =
              item[field.name] || extractedItem[field.name] || "";
          });
        } else if (structureType === "vendor9") {
          lineItemConfig.fields.forEach((field) => {
            let outputKey = field.name;
            if (outputKey.endsWith("Final")) {
              outputKey = outputKey.replace("Final", "");
            }
            let inputKey = outputKey;

            if (outputKey === "itemCode") inputKey = "Item Code";
            else if (outputKey === "description")
              inputKey = "Description of Goods";
            else if (outputKey === "quantity") inputKey = "Quantity";
            else if (outputKey === "unitPrice") inputKey = "Unit Price";
            else if (outputKey === "amountBeforeVat")
              inputKey = "Amount Before VAT";
            else if (outputKey === "taxAmount") inputKey = "Tax Amount";
            else if (outputKey === "totalAmount") inputKey = "Total Amount";
            else if (outputKey === "hsCode") inputKey = "HS Code";
            else if (outputKey === "poNumber") inputKey = "PO Number";

            obj[`${outputKey}Extracted`] = extractedItem[inputKey] || "";
            obj[`${outputKey}Final`] =
              item[field.name] || extractedItem[inputKey] || "";
          });
        }

        return obj;
      });
    }

    const finalPayload = {
      headerData,
      structuredKeyValue,
    };

    try {
      const res = await saveExtractedData(finalPayload, jwtToken);
      if (res.status) {
        toast.success("Data saved successfully");
        setExtractedData({});
        setFinalData({});
        setSelectedImage(null);
        setButtonName("Submit Data");
      } else {
        toast.error("Save failed");
        setButtonName("Submit Data");
      }
    } catch (err) {
      toast.error("Save error");
      setButtonName("Submit Data");
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div>
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <MDBox ml={2} mt={6}>
              <MDTypography variant="h4" fontWeight="medium">
                OCR
              </MDTypography>
            </MDBox>
          </div>
          <div>
            <Card sx={{ width: "90%", margin: "30px auto" }}>
              <MDBox p={2}>
                <MDTypography variant="h5">OCR </MDTypography>

                <Select
                  placeholder="Select Supplier"
                  options={[
                    { label: "vendor4", value: "vendor4" },
                    { label: "vendor5", value: "vendor5" },
                    { label: "vendor6", value: "vendor6" },
                    { label: "vendor7", value: "vendor7" },
                    { label: "vendor8", value: "vendor8" },
                    { label: "vendor9", value: "vendor9" },
                  ]}
                  value={
                    structureType
                      ? { label: structureType, value: structureType }
                      : null
                  }
                  onChange={handleStructureChange}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: "#fff",
                      zIndex: 9999,
                    }),
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "#fff",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                      color: "#000",
                    }),
                  }}
                />

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ marginTop: "10px" }}
                />

                <MDButton
                  color="info"
                  style={{ marginTop: "10px" }}
                  onClick={handleExtract}
                  disabled={!structureType || !selectedImage || !uploadAccess}
                >
                  Upload
                </MDButton>

                <form onSubmit={handleSubmitExtracted}>
                  <MDBox mt={2}>
                    <Grid container spacing={2}>
                      {structureFields[structureType]
                        ?.filter((field) => field.name !== "lineItem")
                        .map((field) => (
                          <Grid item xs={12} sm={6} md={3} key={field.name}>
                            <MDInput
                              label={field.label}
                              name={field.name}
                              value={finalData[field.name] || ""}
                              onChange={handleExtractedInputChange}
                              fullWidth
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </MDBox>

                  {/* Divider before Line Items */}
                  {structureFields[structureType]?.some(
                    (f) => f.name === "lineItem",
                  ) && (
                    <>
                      <hr style={{ margin: "20px 0" }} />
                      {/* <strong >Line Items</strong> */}
                      <MDBox
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        {(finalData?.lineItem || []).map((item, index) => (
                          <Grid
                            container
                            spacing={2}
                            key={index}
                            sx={{
                              width: "90%",
                              marginBottom: 2,
                              marginTop: 1,
                              padding: 1,
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              background: "#f9f9f9",
                              // maxWidth: "1000px",
                            }}
                          >
                            <Grid item xs={12}>
                              <MDTypography variant="h6">
                                Line Item - {index + 1}
                              </MDTypography>
                            </Grid>

                            {structureFields[structureType]
                              .find((f) => f.name === "lineItem")
                              ?.fields.map((field) =>
                                field.name === "Description" ? (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    key={field.name}
                                  >
                                    <MDInput
                                      label={field.label}
                                      name={field.name}
                                      value={item[field.name] || ""}
                                      onChange={(e) => {
                                        const updatedItems = [
                                          ...finalData.lineItem,
                                        ];
                                        updatedItems[index][field.name] =
                                          e.target.value;
                                        setFinalData({
                                          ...finalData,
                                          lineItem: updatedItems,
                                        });
                                      }}
                                      multiline
                                      minRows={2}
                                      maxRows={4}
                                      fullWidth
                                    />
                                  </Grid>
                                ) : (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    key={field.name}
                                  >
                                    <MDInput
                                      label={field.label}
                                      name={field.name}
                                      value={item[field.name] || ""}
                                      onChange={(e) => {
                                        const updatedItems = [
                                          ...finalData.lineItem,
                                        ];
                                        updatedItems[index][field.name] =
                                          e.target.value;
                                        setFinalData({
                                          ...finalData,
                                          lineItem: updatedItems,
                                        });
                                      }}
                                      fullWidth
                                    />
                                  </Grid>
                                ),
                              )}
                          </Grid>
                        ))}
                      </MDBox>
                    </>
                  )}

                  <MDButton
                    color="success"
                    type="submit"
                    style={{ marginTop: "10px" }}
                    // disabled={(() => {
                    //   if (loading) return true;
                    //   // Check header fields
                    //   const headerFields =
                    //     structureFields[structureType]?.filter(
                    //       (f) => f.name !== "lineItem"
                    //     ) || [];
                    //   const allHeaderFilled = headerFields.every(
                    //     (f) =>
                    //       finalData[f.name] &&
                    //       String(finalData[f.name]).trim() !== ""
                    //   );
                    //   // Check line items if present
                    //   const lineItemConfig = structureFields[
                    //     structureType
                    //   ]?.find((f) => f.name === "lineItem");
                    //   if (lineItemConfig) {
                    //     const lineItems = finalData.lineItem || [];
                    //     if (!lineItems.length) return true;
                    //     // All line items must have all fields filled
                    //     const allLineItemsFilled = lineItems.every((item) =>
                    //       lineItemConfig.fields.every(
                    //         (field) =>
                    //           item[field.name] &&
                    //           String(item[field.name]).trim() !== ""
                    //       )
                    //     );
                    //     return !(allHeaderFilled && allLineItemsFilled);
                    //   }
                    //   return !allHeaderFilled;
                    // })()}
                  >
                    {loading ? (
                      <CircularProgress size={22} color="inherit" />
                    ) : (
                      buttonName
                    )}
                  </MDButton>
                </form>
              </MDBox>
            </Card>
          </div>
          {loading && (
            <Backdrop
              sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

          <ToastContainer />
          <br />
          <br />
          <br />
          <Footer />
        </DashboardLayout>
      </>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    ocrUploadStructure1Reducer: state.ocrUploadStructure1Reducer,
    ocrUploadStructure2Reducer: state.ocrUploadStructure2Reducer,
    ocrUploadStructure3Reducer: state.ocrUploadStructure3Reducer,
    ocrUploadStructure4Reducer: state.ocrUploadStructure4Reducer,
    ocrUploadStructure5Reducer: state.ocrUploadStructure5Reducer,
    ocrUploadStructure9Reducer: state.ocrUploadStructure9Reducer,
    // getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    uploadStructure01: (formData, jwtToken) =>
      dispatch(uploadStructure01(formData, jwtToken)),
    uploadStructure02: (formData, jwtToken) =>
      dispatch(uploadStructure02(formData, jwtToken)),
    uploadStructure03: (formData, jwtToken) =>
      dispatch(uploadStructure03(formData, jwtToken)),
    uploadStructure04: (formData, jwtToken) =>
      dispatch(uploadStructure04(formData, jwtToken)),
    uploadStructure05: (formData, jwtToken) =>
      dispatch(uploadStructure05(formData, jwtToken)),
    uploadStructure09: (formData, jwtToken) =>
      dispatch(uploadStructure09(formData, jwtToken)),
    saveExtractedData: (finalPayload, jwtToken) =>
      dispatch(saveExtractedData(finalPayload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OCR);
